<h2 mat-dialog-title>
  <mat-icon>check_circle</mat-icon>
  Schedule Validation
</h2>

<mat-dialog-content>
  <div *ngIf="loading" class="loading-container">
    <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    <p>Validating schedule resources...</p>
  </div>

  <div *ngIf="error" class="error-message">
    <mat-icon>error</mat-icon>
    <p>{{ error }}</p>
  </div>

  <div *ngIf="validationResult && !loading && !error">
    <!-- Warnings Section -->
    <div *ngIf="validationResult.warnings && validationResult.warnings.length > 0" class="warnings-section">
      <div class="info-message">
        <mat-icon>info</mat-icon>
        <div>
          <h3>Validation Notes</h3>
          <ul>
            <li *ngFor="let warning of validationResult.warnings">{{ warning }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="validationResult.isValid" class="success-message">
      <mat-icon>check_circle</mat-icon>
      <div>
        <h3>Validation Passed!</h3>
        <p>All non-primary resources have sufficient available time to accommodate the primary resource requirements.</p>
      </div>
    </div>

    <div *ngIf="!validationResult.isValid" class="validation-issues">
      <div class="warning-message">
        <mat-icon>warning</mat-icon>
        <div>
          <h3>Validation Issues Found</h3>
          <p>The following resources do not have enough available time:</p>
        </div>
      </div>

      <mat-accordion class="issues-accordion">
        <mat-expansion-panel *ngFor="let issue of validationResult.issues" class="issue-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="issue-icon">schedule</mat-icon>
              <div class="issue-title">
                <strong>{{ issue.resourceName }}</strong>
                <span class="resource-type-badge">{{ issue.resourceType }}</span>
                <span class="issue-type-badge" [ngClass]="getIssueTypeClass(issue.issueType)">
                  {{ getIssueTypeLabel(issue.issueType) }}
                </span>
              </div>
            </mat-panel-title>
            <mat-panel-description>
              <span *ngIf="issue.shortfall > 0" class="shortfall-badge">
                {{ formatMinutes(issue.shortfall) }} short
              </span>
              <span *ngIf="issue.dayIssues.length > 0" class="day-issues-badge">
                {{ issue.dayIssues.length }} day(s) affected
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="issue-details">
            <div *ngIf="issue.details" class="issue-details-text">
              <mat-icon>info_outline</mat-icon>
              <p>{{ issue.details }}</p>
            </div>
            <div class="summary-row">
              <div class="summary-item">
                <span class="label">Required (Weekly):</span>
                <span class="value">{{ formatMinutes(issue.requiredMinutes) }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Available (Weekly):</span>
                <span class="value">{{ formatMinutes(issue.availableMinutes) }}</span>
              </div>
              <div class="summary-item" *ngIf="issue.shortfall > 0">
                <span class="label">Shortfall (Weekly):</span>
                <span class="value error">{{ formatMinutes(issue.shortfall) }}</span>
              </div>
            </div>

            <div *ngIf="issue.dayIssues.length > 0" class="day-issues">
              <h4>Per-Day Issues:</h4>
              <div class="day-issue" *ngFor="let dayIssue of issue.dayIssues">
                <div class="day-name">{{ dayIssue.dayName }}</div>
                <div class="day-details">
                  <span>Required: <strong>{{ formatMinutes(dayIssue.requiredMinutes) }}</strong></span>
                  <span>Available: <strong>{{ formatMinutes(dayIssue.availableMinutes) }}</strong></span>
                  <span class="error">Short: <strong>{{ formatMinutes(dayIssue.shortfall) }}</strong></span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-flat-button color="primary" (click)="validateSchedule()" *ngIf="error">
    <mat-icon>refresh</mat-icon>
    Retry
  </button>
</mat-dialog-actions>
